import { z } from "zod";

/**
 * Template group for multi-language support
 */
export const TemplateGroupSchema = z.object({
  baseName: z.string(),
  availableLanguages: z.array(
    z.object({
      language: z.string(),
      templateId: z.string()
    })
  ),
  defaultLanguage: z.string().optional()
});

export type TemplateGroup = z.infer<typeof TemplateGroupSchema>;
